<template>
  <ul
    v-if="list.length"
    v-rellax="{ list, rellaxSpeed }"
    class="categories-list">
    <li
      v-for="(product, index) of list"
      :key="index"
      class="category-list__category_hover">
      <router-link :to="{ name: `${lang}.single-product`, params: { slug: product.fields.slug } }">
        <img
          v-if="typeof product.fields.productThumbnail !== 'undefined'"
          :src="product.fields.productThumbnail.fields.file.url"
          loading="lazy"
          :alt="product.fields.productThumbnail.fields.description"
          :width="product.fields.productThumbnail.fields.file.details.image.width"
          :height="product.fields.productThumbnail.fields.file.details.image.height"
          class="category-list__category_hover__img">
        <p>{{ product.fields.title }}</p>
        <span
          v-if="typeof product.fields.listingFeatures !== 'undefined'" v-html="product.fields.listingFeatures + ' | ' + product.fields.productCode" />
        <SingleProductListHasTags :product="product" />
      </router-link>
    </li>
  </ul>
</template>

<script>

import Rellax from 'rellax'
import SingleProductListHasTags from '@/components/SingleProductListHasTags/SingleProductListHasTags.vue'
import { mapGetters } from 'vuex'

export default {
  name: 'TagCategoryList',
  components: {
    SingleProductListHasTags
  },
  data: () => ({
    loading: true,
    rellaxRef: undefined,
    lazyLoading: require('@/assets/lazy/tag-category-product.png')
  }),
  props: {
    list: {
      type: Array,
      required: true
    },
    rellaxSpeed: {
      type: Number,
      default: undefined
    }
  },
  computed: {
    ...mapGetters([
      'lang'
    ]),
  },
  directives: {
    'rellax': {
      inserted (el, binding, vnode) {
        if (typeof binding.value.rellaxSpeed !== 'undefined') {
          const rellaxRef = new Rellax(el, {
            speed: binding.value.rellaxSpeed,
            center: false,
            wrapper: null,
            round: true,
            vertical: true,
            horizontal: false
          })
          vnode.context.$data.rellax = rellaxRef
        }
      },
      componentUpdated (el, binding, vnode) {
        if (typeof binding.value.rellaxSpeed !== 'undefined') vnode.context.$data.rellax.refresh()
      },
      unbind (el, binding, vnode) {
        if (typeof binding.value.rellaxSpeed !== 'undefined') vnode.context.$data.rellax.destroy()
      }
    }
  }
}
</script>

<style lang="scss">
  @import "./list.scss";
</style>
